import { Input, InputProps } from 'antd';
import React, { FC } from 'react';

interface IProps extends InputProps {}

const NumberInput: FC<IProps> = props => {
  return <Input {...props} type="number" pattern="[0-9]+([,\.][0-9]+)?" />;
};

export default NumberInput;
